import { render, staticRenderFns } from "./lavora-con-noi.vue?vue&type=template&id=acfdd798&"
import script from "./lavora-con-noi.vue?vue&type=script&lang=ts&"
export * from "./lavora-con-noi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsThePageTitleSection: require('/usr/src/nuxt-app/components/elements/ThePageTitleSection.vue').default,ElementsTheNotice: require('/usr/src/nuxt-app/components/elements/TheNotice.vue').default,ElementsInputWithValidation: require('/usr/src/nuxt-app/components/elements/InputWithValidation.vue').default})
